export type ManufacturingViewType = {
    id: string;
    title: string;
    title_code: string;
};

export type ManufacturingViewTypes = {
    [key: string]: ManufacturingViewType;
};

export const HOME_VIEW_TYPES: ManufacturingViewTypes = {
    overview: { id: "overview", title: "overview", title_code: "Manufacturing.HomeView.overview" },
};

export const LINES_VIEWS_VIEW_TYPES: ManufacturingViewTypes = {
    gantt: { id: "gantt", title: "gantt", title_code: "Manufacturing.LinesView.gantt" },
    microplan: { id: "microplan", title: "microplan", title_code: "Manufacturing.LinesView.microplan" },
    layout: { id: "layout", title: "layout", title_code: "Manufacturing.LinesView.layout" },
    realization: { id: "realization", title: "realization", title_code: "Manufacturing.LinesView.realization" },
    orders_and_shifts: {
        id: "orders_and_shifts",
        title: "orders_and_shifts",
        title_code: "Manufacturing.LinesView.orders_and_shifts",
    },
    planning_table: {
        id: "planning_table",
        title: "planning_table",
        title_code: "Manufacturing.LinesView.planning_table",
    },
    batch_op: { id: "batch_op", title: "batch_op", title_code: "Manufacturing.LinesView.batch_op" },
    subcontracting: {
        id: "subcontracting",
        title: "subcontracting",
        title_code: "Manufacturing.LinesView.subcontracting",
    },
    manual_order_entry: {
        id: "manual_order_entry",
        title: "Manually entered orders",
        title_code: "Manufacturing.LinesView.manual_order_entry",
    },
    plan_change: { id: "plan_change", title: "plan change", title_code: "Manufacturing.LinesView.plan_change" },
    plan_insights: { id: "plan_insights", title: "plan insights", title_code: "Manufacturing.LinesView.plan_insights" },
    downtimes: { id: "downtimes", title: "downtimes", title_code: "Manufacturing.LinesView.downtimes" },
    prediction_vs_real: { id: "prediction_vs_real", title: "Evaluation", title_code: "Header.menu.manufacturing_eval" },
    preplanning: { id: "preplanning", title: "Preplanning", title_code: "Manufacturing.LinesView.preplanning" },
};

export const STOCKS_VIEWS_VIEW_TYPES: ManufacturingViewTypes = {
    stock_forecast: {
        id: "stock_forecast",
        title: "stock forecast",
        title_code: "Manufacturing.StocksView.stock_forecast",
    },
    long_term_stock_forecast: {
        id: "long_term_stock_forecast",
        title: "long-term stock forecast",
        title_code: "Manufacturing.StocksView.long_term_stock_forecast",
    },
    stock_status: { id: "stock_status", title: "stock status", title_code: "Manufacturing.StocksView.stock_status" },
    out_of_stock: { id: "out_of_stock", title: "out of stock", title_code: "Manufacturing.StocksView.out_of_stock" },
    stock_requirements_inbounds: {
        id: "stock_requirements_inbounds",
        title: "stock requirements_inbounds",
        title_code: "Manufacturing.StocksView.stock_requirements_inbounds",
    },
    stock_requirements_outbounds: {
        id: "stock_requirements_outbounds",
        title: "stock requirements_outbounds",
        title_code: "Manufacturing.StocksView.stock_requirements_outbounds",
    },
    stock_requirements_delay: {
        id: "stock_requirements_delay",
        title: "steck requirements delay",
        title_code: "Manufacturing.StocksView.stock_requirements_delay",
    },
    kanban: { id: "kanban", title: "kanban", title_code: "Manufacturing.StocksView.kanban" },
};

export const TOOLS_VIEW_TYPES: ManufacturingViewTypes = {
    gantt_tools: { id: "gantt_tools", title: "gantt", title_code: "Manufacturing.ToolsView.gantt" },
    tool_change: { id: "tool_change", title: "Tool changes", title_code: "Manufacturing.ToolsView.tool_change" },
    tool_change_new: {
        id: "tool_change_new",
        title: "Tool changes",
        title_code: "Manufacturing.ToolsView.tool_change",
    },
    tool_management: {
        id: "tool_management",
        title: "Tool management",
        title_code: "Manufacturing.ToolsView.tool_management",
    },
};

export const PEOPLE_VIEW_TYPES: ManufacturingViewTypes = {
    shifts: { id: "shifts", title: "Shift-board", title_code: "Manufacturing.PeopleView.shifts" },
    people_insights: {
        id: "people_insights",
        title: "People insights",
        title_code: "Manufacturing.PeopleView.people_insights",
    },
    workforce_kpis: {
        id: "workforce_kpis",
        title: "Workforce KPIs",
        title_code: "common.kpis",
    },
};
